import { formatToCLP } from '../formatToCLP';
import { formatToMillions } from '../formatToMillions';

export type CurrencyFormat = 'full' | 'millions';

const formatFunctions: Record<CurrencyFormat, (value: number) => string> = {
  full: formatToCLP,
  millions: formatToMillions,
};

const formatToCurrency = (value: number, format: CurrencyFormat = 'full') => {
  const formatter = formatFunctions[format];

  return formatter(value);
};

export { formatToCurrency };
